import React, { useState, useRef, useEffect, useCallback } from 'react';
import Tab from '@/ui/tab/tab';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useMarketData, useGlobalValueStore } from '@bitbot/model';
import { TokenWithChainIcon } from '@/ui/tokenImage';
import { formatEnglishNumber } from '@/utils';
import LoadingMarketDataSkeleton from '../common/skeleton/loading-market-data';
import DecimalFormat from '../common/decimal-format';
import { sendGAEvent } from '@next/third-parties/google';

export default function HomeTab() {
  const tabs: { name: string; value: 'trending' | 'top' | 'favorite' }[] =
    [
      {
        name: 'Trending',
        value: 'trending',
      },
      {
        name: 'Top',
        value: 'top',
      },
      // {
      //   name: 'Favorite',
      //   value: 'favorite',
      // },
    ];
  const [activeTab, setActiveTab] =
    useState<(typeof tabs)[number]['value']>('trending');

  const _setActiveTab = useCallback(
    (value: (typeof tabs)[number]['value']) => {
      setActiveTab(value);
      sendGAEvent('event', `click_home_${value}`);
    },
    [setActiveTab],
  );

  const tabRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);
  const { homeScrollRef } = useGlobalValueStore();
  useEffect(() => {
    if (tabRef.current && listRef.current && homeScrollRef.current) {
      //判断tabRef距离顶部的距离
      const tabDis = tabRef.current.getBoundingClientRect().top;
      const listDis = listRef.current.getBoundingClientRect().top;
      // homeScrollRef.current.scrollBy(0, )
      if (listDis < 72) {
        homeScrollRef.current.scrollBy(0, listDis - 72);
      }
    }
  }, [activeTab]);

  return (
    <div>
      <div className="pt-2 pb-1 sticky top-0 z-20 bg-primary" ref={tabRef}>
        <Tab
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={_setActiveTab}
        />
        <div className="flex uppercase text-tertiary text-xs leading-[16px] mt-4">
          <div className="flex-grow">Token</div>
          <div className="w-[100px] text-right">Market Cap</div>
          <div className="w-[25%] text-right">24H</div>
        </div>
      </div>

      <div className="mb-3" ref={listRef}>
        <List type={activeTab} />
      </div>
    </div>
  );
}

function List({ type }: { type: 'trending' | 'top' | 'favorite' }) {
  const router = useRouter();
  const {
    pairList,
    favList,
    topList,
    isFavLoading,
    isLoading,
    isTopLoading,
  } = useMarketData();
  const list =
    type === 'trending' ? pairList : type === 'top' ? topList : favList;

  return (
    <div className="flex flex-col text-tertiary text-xs leading-[16px] pb-1 min-h-[calc(100vh-72px)]">
      {type === 'trending' && isLoading && <LoadingMarketDataSkeleton />}
      {type === 'top' && isTopLoading && <LoadingMarketDataSkeleton />}
      {type === 'favorite' && isFavLoading && (
        <LoadingMarketDataSkeleton />
      )}
      {/* {type === 'trending' && topList && topList.length > 0 && (
        <div
          className="flex py-4 items-center cursor-pointer"
          onClick={() => {
            router.push(`/trade?pairAddress=${topList[0].pairAddress}`);
            sendGAEvent(
              'event',
              `trade_${topList[0].baseToken.symbol}_${topList[0].quoteToken.symbol}`,
            );
          }}
        >
          <div className="flex-grow flex items-center gap-4">
            <TokenWithChainIcon
              chainName={topList[0].chainId}
              chainSrc="/chain/base.svg"
              tokenName={topList[0].baseToken.symbol}
              tokenSrc={topList[0].logo}
              className="w-[2rem] h-[2rem]"
              borderWidth={4}
            />
            <div className="flex flex-col">
              <div className="flex items-center gap-1">
                <div className="text-base font-bold leading-[1.5] text-primary max-w-[20vw] truncate">
                  {topList[0].baseToken.symbol}
                </div>
                /<span>{topList[0].quoteToken.symbol}</span>
              </div>
              <div className="leading-none">
                {' '}
                {topList[0].baseToken.name}
              </div>
            </div>
          </div>
          <div className="w-[100px] text-right flex flex-col">
            <div className="text-primary font-bold leading-[1.5] text-base">
              {formatEnglishNumber(+topList[0].fdv)}
            </div>
            <div className="leading-[16px] self-end">
              <DecimalFormat
                value={topList[0].priceUsd}
                isUsd
                format={4}
              />
            </div>
          </div>
          <div className="w-[25%] flex justify-end">
            <div
              className={clsx(
                'h-7 flex items-center justify-center text-base font-bold text-right',
                +topList[0].priceChange.h24 < 0
                  ? 'text-red-accent'
                  : 'text-green-accent',
              )}
            >
              {+topList[0].priceChange.h24 >= 0 ? '+' : '-'}
              {formatEnglishNumber(Math.abs(+topList[0].priceChange.h24))}%
            </div>
          </div>
        </div>
      )} */}
      {/* extra hardcode another trending token*/}
      {/* {type === 'trending' && topList && topList.length > 2 && (
        <div
          className="flex py-4 items-center cursor-pointer"
          onClick={() => {
            router.push(`/trade?pairAddress=${topList[2].pairAddress}`);
            sendGAEvent(
              'event',
              `trade_${topList[2].baseToken.symbol}_${topList[2].quoteToken.symbol}`,
            );
          }}
        >
          <div className="flex-grow flex items-center gap-4">
            <TokenWithChainIcon
              chainName={topList[2].chainId}
              chainSrc="/chain/base.svg"
              tokenName={topList[2].baseToken.symbol}
              tokenSrc={topList[2].logo}
              className="w-[2rem] h-[2rem]"
              borderWidth={4}
            />
            <div className="flex flex-col">
              <div className="flex items-center gap-1">
                <div className="text-base font-bold leading-[1.5] text-primary max-w-[20vw] truncate">
                  {topList[2].baseToken.symbol}
                </div>
                /<span>{topList[2].quoteToken.symbol}</span>
              </div>
              <div className="leading-none">
                {' '}
                {topList[2].baseToken.name}
              </div>
            </div>
          </div>
          <div className="w-[100px] text-right flex flex-col">
            <div className="text-primary font-bold leading-[1.5] text-base">
              {formatEnglishNumber(+topList[2].fdv)}
            </div>
            <div className="leading-[16px] self-end">
              <DecimalFormat
                value={topList[2].priceUsd}
                isUsd
                format={4}
              />
            </div>
          </div>
          <div className="w-[25%] flex justify-end">
            <div
              className={clsx(
                'h-7 flex items-center justify-center text-base font-bold text-right',
                +topList[2].priceChange.h24 < 0
                  ? 'text-red-accent'
                  : 'text-green-accent',
              )}
            >
              {+topList[2].priceChange.h24 >= 0 ? '+' : '-'}
              {formatEnglishNumber(Math.abs(+topList[2].priceChange.h24))}%
            </div>
          </div>
        </div>
      )} */}
      {list.map((pair, index) => {
        return (
          <div
            className="flex py-4 items-center cursor-pointer"
            key={index}
            onClick={() => {
              router.push(`/trade?pairAddress=${pair.pairAddress}`);
              sendGAEvent(
                'event',
                `trade_${pair.baseToken.symbol}_${pair.quoteToken.symbol}`,
              );
            }}
          >
            <div className="flex-grow flex items-center gap-4">
              <TokenWithChainIcon
                chainName={pair.chainId}
                chainSrc="/chain/base.svg"
                tokenName={pair.baseToken.symbol}
                tokenSrc={pair.logo}
                className="w-[2rem] h-[2rem]"
                borderWidth={4}
              />
              <div className="flex flex-col">
                <div className="flex items-center gap-1">
                  <div className="text-base font-bold leading-[1.5] text-primary max-w-[20vw] truncate">
                    {pair.baseToken.symbol}
                  </div>
                  /<span>{pair.quoteToken.symbol}</span>
                </div>
                <div className="leading-none"> {pair.baseToken.name}</div>
              </div>
            </div>
            <div className="w-[100px] text-right flex flex-col">
              <div className="text-primary font-bold leading-[1.5] text-base">
                {formatEnglishNumber(+pair.fdv)}
              </div>
              <div className="leading-[16px] self-end">
                <DecimalFormat value={pair.priceUsd} isUsd format={4} />
              </div>
            </div>
            <div className="w-[25%] flex justify-end">
              <div
                className={clsx(
                  'h-7 flex items-center justify-center text-base font-bold text-right',
                  +pair.priceChange.h24 < 0
                    ? 'text-red-accent'
                    : 'text-green-accent',
                )}
              >
                {+pair.priceChange.h24 >= 0 ? '+' : '-'}
                {formatEnglishNumber(Math.abs(+pair.priceChange.h24))}%
              </div>
            </div>
          </div>
        );
      })}
      {type === 'favorite' && !isFavLoading && list.length === 0 && (
        <div className="pt-[120px] font-nunito_sans">
          <div className="text-lg text-center text-primary leading-[26px] font-bold">
            Your favorites list is empty
          </div>
          <div className="text-tertiary text-center pt-2 text-base">
            Browse and favorite tokens
          </div>
        </div>
      )}
    </div>
  );
}
